<template>
  <div>
    <index-carousel v-if="this.indexCarouselState === 1"></index-carousel>
    <game-center v-if="this.gameCenterState === 1"></game-center>
    <qq-group v-if="this.gameGroupState"></qq-group>
    <company-profile v-if="this.companyProfileState === 1"></company-profile>
    <news-center v-if="this.newsCenterState === 1"></news-center>
    <careers v-if="this.careersState === 1"></careers>

  </div>
</template>

<script>
import IndexCarousel from "../components/index/IndexCarousel";
import GameCenter from "../components/index/GameCenter";
import NewsCenter from "../components/index/NewsCenter";
import CompanyProfile from "../components/index/CompanyProfile";
import Careers from "../components/index/Careers";
import QqGroup from "../components/index/QqGroup";

export default {
  name: "Home",
  data() {
    return {
      indexCarouselState: 1,
      gameCenterState: 1,
      companyProfileState: 1,
      newsCenterState: 1,
      careersState: 1,
      gameGroupState: 1
    };
  },
  mounted() {
    this.getIndexPartList();
  },
  components: {
    IndexCarousel,
    GameCenter,
    CompanyProfile,
    NewsCenter,
    Careers,
    QqGroup
  },
  methods: {
    getIndexPartList() {
      this.axios
        .get("/indexPart/getPartList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.indexCarouselState = resp.data.data.indexCarouselState;
            this.gameCenterState = resp.data.data.gameCenterState;
            this.companyProfileState = resp.data.data.companyProfileState;
            this.newsCenterState = resp.data.data.newsCenterState;
            this.careersState = resp.data.data.careersState;
            this.gameGroupState = resp.data.data.gameGroupState;
          }
        })
        .catch();
    }
  }
};
</script>
